import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import store from '@/store/modules/user'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function(value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('rateAmount', function(value) {
  return (
    (store.state.cur === 'USD' ? '$' : store.state.cur === 'CNY' ? '￥' : store.state.cur) +
    (Number(value) * (store.state.cur === 'USD' ? 1.0 : store.state.rate)).toFixed(2)
  )
})

Vue.filter('rateAmountNum', function(value) {
  return (Number(value) * (store.state.cur === 'USD' ? 1.0 : store.state.rate)).toFixed(2)
})

// 修正金额专用过滤器：将 +/- 符号放在货币符号前面，如 +$10.00 或 -$5.00
Vue.filter('rateAmountWithSign', function(value) {
  const numValue = Number(value)
  const rate = store.state.cur === 'USD' ? 1.0 : store.state.rate
  const absAmount = Math.abs(numValue * rate).toFixed(2)
  const sign = numValue >= 0 ? '+' : '-'
  const curSymbol = store.state.cur === 'USD' ? '$' : store.state.cur === 'CNY' ? '￥' : store.state.cur
  return sign + curSymbol + absAmount
})

Vue.filter('rateAmountLocal', function(value) {
  const cur = Vue.ls.get('cur') ? Vue.ls.get('cur') : store.state.cur
  return (
    (cur === 'USD' ? '$' : cur === 'CNY' ? '￥' : cur) +
    (
      Number(value) * (Vue.ls.get('rate') ? Vue.ls.get('rate') : store.state.cur === 'USD' ? 1.0 : store.state.rate)
    ).toFixed(2)
  )
})
Vue.filter('removeTrailingZeros', function(num) {
  return num.toFixed(10).replace(/\.?0+$/, '')
})
